module.exports = __webpack_public_path__ + "static/media/loader.293ebb36.svg";